import React, { useState, useEffect } from "react"

import styles from "./titleBannerV2.module.scss"

/*
TABLE OF PROPS

PROP | TYPE | DESCRIPTION
----------------------------
title     | string  | Main Title Text
subtitle  | string  | Subtitle Text
size      | string  | small, default: normal

*/

export default function TitleBannerV2(props) {

  return (
    <>
      <div className={styles.titleBanner}>
        <h2 className={styles.title + ' ' + (props?.size == 'small' ? styles.small : '')}>
          <span>{props.title}</span>
        </h2>
        <br></br>
        <br></br>
        <br></br>
        <h4 className={styles.subtitle + ' ' + (props?.size == 'small' ? styles.small : '')}>
          {props.subtitle} {props.discount} {props.variants ? ' / ' + props.variants : ''}
        </h4>
      </div>
    </>
  )
}
